<template>
  <div class="main-content">
    <div class="h2"><strong>使用者登錄</strong></div>
    <div class="subtitle">
      尚未註冊過此帳號？
      <a href="#" @click="$store.commit('setLoginCurrentContent', 'register')">帳戶註冊</a>
    </div>
    <div class="form-div">
      <input type="email" class="form-input" id="input-email" placeholder=" " v-model="user_email">
      <label for="input-email" class="form-label">使用者電子信箱</label>
    </div>
    <div class="form-div">
      <input :type="show_password ? 'text' : 'password'" class="form-input" id="input-password" placeholder=" "
        v-model="user_password">
      <label for="input-password" class="form-label">登錄密碼</label>
      <div type="button" class="switch-password" v-show="show_password" @click="show_password = !show_password">
        <i class="fa-regular fa-eye-slash"></i>
      </div>
      <div type="button" class="switch-password" v-show="!show_password" @click="show_password = !show_password">
        <i class="fa-regular fa-eye"></i>
      </div>
    </div>
    <div class="send-bag">
      <div id="error-password" class="text-danger"></div>
      <button class="form-button bg-success" @click="userLogin">使用者登錄</button>
    </div>
    <a href="#" @click="$store.commit('setLoginCurrentContent', 'forget-password')">忘記密碼</a>
    <hr>
    <div class="login-logo">
      <img :src="base_url + '/images/logo.png'" alt="">
    </div>
    <copyright-component></copyright-component>
  </div>
</template>

<script>
import CopyrightComponent from '../layouts/CopyrightComponent.vue';
import { validation } from '../mixins/validation.js';
import { axiosMixins } from '../mixins/axiosErrorMessage.js';

export default {
  components: { CopyrightComponent },
  mixins: [validation, axiosMixins],
  data() {
    return {
      base_url: base_url,
      show_password: false,
      user_email: '',
      user_password: '',
    }
  },
  methods: {
    userLogin() {
      if (!this.validateBeforeSubmit()) { return }
      axios.post(base_url + '/api/login', {
        account: this.user_email,
        password: this.user_password,
      }).then((response) => {
        const user = {
          id: response.data.id,
          name: response.data.name,
          email: response.data.email,
        };
        localStorage.setItem('token', "Bearer " + response.data.token);
        localStorage.setItem('user_info', JSON.stringify(user));
        // 若登入裝置為 ha
        if (window.location.href.endsWith("/ha")) {
          this.$router.push({ name: "ha-page" });
        } else {
          this.$router.push({ name: 'home' });
        }
      }).catch((error) => {
        this.axiosMessage(error);
        const error_element = this.$el.querySelector('#error-password')
        error_element.innerHTML = "帳號或密碼錯誤";
        setTimeout(() => {
          error_element.innerHTML = "";
        }, 3000);
      });
    },
  },
}
</script>
